module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.seller.sellerKey.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seller.region))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "ui input focus",
    attrs: {
      "required": "true",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.authToken))]), _vm._v(" "), (_vm.showAdvertisementApiSettings) ? _c('td', [(_vm.seller.connectedToAdvertisementApi) ? _c('center', [_c('i', {
    staticClass: "check circle outline icon"
  })]) : _c('center', [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Authorize SentryKit to access Advertisement data"
    },
    on: {
      "click": _vm.redirectToAdvertisementAuthPage
    }
  }, [_c('i', {
    staticClass: "plug icon"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.anyAccountMayNeedReAuthorization) ? _c('td', {
    staticClass: "one wide"
  }, [_c('div', {
    attrs: {
      "data-tooltip": "May Need Re-Authorization"
    }
  }, [(_vm.seller.mayNeedReauthorization) ? _c('i', {
    staticClass: "exclamation triangle icon"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "one wide"
  }, [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Re-Authorize"
    },
    on: {
      "click": function($event) {
        return _vm.reauthorize()
      }
    }
  }, [_c('i', {
    staticClass: "linkify icon"
  })])]), _vm._v(" "), (_vm.isOwner) ? _c('td', {
    staticClass: "one wide"
  }, [_c('button', {
    staticClass: "ui icon button",
    attrs: {
      "type": "button",
      "data-tooltip": "Delete Account"
    },
    on: {
      "click": function($event) {
        return _vm.requestDeleteAccount()
      }
    }
  }, [_c('i', {
    staticClass: "trash alternate outline icon"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6070c3d1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SellerAccount.vue
// module id = 783
// module chunks = 2